import moment from 'moment';
import SectionHeader from './ui/SectionHeader';
import TrackSegmentedControl from './TrackSegmentedControl';
import DropdownSelect from './DropdownSelect';
import MonthPicker from './MonthPicker';

// Desktop header of the monthly cards: the filters now live with the cards
// they drive instead of in a separate filter card.
export default function MonthlySectionHeader({ track, onTrack, horizon, onHorizon, horizons, year, month, onMonth }) {
  const horizonOptions = horizons.map((h) => ({ value: h, label: h === 0 ? 'Intraday' : `D+${h}` }));
  return (
    <SectionHeader
      title="This month"
      description={`Rankings and submissions for ${moment({ year, month: month - 1 }).format('MMMM YYYY')}`}
      actions={(
        <>
          <TrackSegmentedControl selectedTrack={track} onSelectTrack={onTrack} showMetric />
          <DropdownSelect value={horizon} options={horizonOptions} onChange={onHorizon} widthClass="w-28" disabled={horizonOptions.length === 0} />
          <MonthPicker year={year} month={month} onChange={({ year: y, month: m }) => onMonth(y, m)} />
        </>
      )}
    />
  );
}
